import { TaskStatus } from '@workingclock/types';
import { z } from 'zod';


export const createClientSchema = z.object({
  name: z.string().min(1).max(160),
});
export type CreateClientInput = z.infer<typeof createClientSchema>;
export const updateClientSchema = createClientSchema.partial().extend({
  archived: z.boolean().optional(),
});
export type UpdateClientInput = z.infer<typeof updateClientSchema>;

export const createProjectSchema = z.object({
  name: z.string().min(1).max(160),
  clientId: z.string().uuid().nullable().optional(),
  color: z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/)
    .default('#6366F1'),
  billable: z.boolean().default(false),
  rate: z.number().min(0).nullable().optional(),
  /** Time budget in hours. Null clears the estimate (and with it the completion percentage). */
  estimatedHours: z.number().min(0).max(1_000_000).nullable().optional(),
});
export type CreateProjectInput = z.infer<typeof createProjectSchema>;
export const updateProjectSchema = createProjectSchema.partial().extend({
  archived: z.boolean().optional(),
});
export type UpdateProjectInput = z.infer<typeof updateProjectSchema>;

export const createTaskSchema = z.object({
  name: z.string().min(1).max(160),
  status: z.nativeEnum(TaskStatus).default(TaskStatus.Active),
  assigneeId: z.string().uuid().nullable().optional(),
});
export type CreateTaskInput = z.infer<typeof createTaskSchema>;
export const updateTaskSchema = createTaskSchema.partial();
export type UpdateTaskInput = z.infer<typeof updateTaskSchema>;

export const createTagSchema = z.object({
  name: z.string().min(1).max(80),
});
export type CreateTagInput = z.infer<typeof createTagSchema>;
export const updateTagSchema = createTagSchema.partial();
export type UpdateTagInput = z.infer<typeof updateTagSchema>;
